import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { LmsIcon, NoData, ViewIconNew } from '../../theme/SvgIcons';
import { Pagination, Table, DatePicker, Breadcrumb } from 'antd';
import {
  DarkText,
  FlexWrapper,
  HighlightText,
  PaginationBox,
  ViewIconBox,
  LinkStyled
} from '../../theme/common_style';
import Title from 'antd/es/typography/Title';
import { toast } from 'react-toastify';
import {
  convertToLocalDate,
  debounce,
  formatDuration,
  generateEmployeeImgUrl,
  getFullName
} from '../../utils/common_functions';
import { StickyBox } from '../../utils/style';
import dayjs from 'dayjs';
import {
  getBillableFullTimeEmployees,
  getEmployeeActiveProjectBilling,
  getEmployeeActiveProjectsByRange,
  getEmployeeDepartmentWiseBiliingByRange,
  getEmployeeProjectBillingCounts,
  getEmployeeWiseBillingReportingByRange,
  getNonBillableFullTimeEmployees,
  getNoProjectEmployees,
  getTotalClientBilling,
  getTotalLeavesEmployees
} from '../../services/api_collection';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import { useLocation, useNavigate } from 'react-router-dom';
// import { FlexWrapperCard } from '../client/ClientRoot';
import styled from '@emotion/styled';
import SearchField from '../../components/searchField/SearchField';
// import ReportsCard from './ReportsCard';
import ProjectBillingTooltip from './BillingTooltip';
import DetailsDayModal from './DetailsDayModal';
import ClientBillingCard, { SkeletonCardClient } from './ClientBillingCard';
import { type } from './ViewReport';
import { BillingCard, DepartmentCard, SkeletonCard } from './RCards';
// import TypeCards from './FronSelect';

const today = dayjs().subtract(1, 'day');
const oneYearAgo = dayjs().subtract(1, 'year');

// const selectType = [
//   { label: type.NOPROJECT, value: type.NOPROJECT },
//   { label: type.NONBILLABLE, value: type.NONBILLABLE },
//   { label: type.BILLABLE, value: type.BILLABLE },
//   { label: type.ACTIVE_DAYS, value: type.ACTIVE_DAYS },
//   { label: type.BILLING_HOURS, value: type.BILLING_HOURS },
//   { label: type.TOTAL_LEAVES_BY_EMPLOYEES, value: type.TOTAL_LEAVES_BY_EMPLOYEES },
//   { label: type.DEPARTMENTS_BILLING, value: type.DEPARTMENTS_BILLING },
//   { label: type.ACTIVE_PROJECT_BILLING, value: type.ACTIVE_PROJECT_BILLING },
//   { label: type.CLIENT_TOTAL_BILLING, value: type.CLIENT_TOTAL_BILLING }
// ];

function Reports() {
  const navigate = useNavigate();
  const reportType = useLocation().state?.reportType;

  const [allData, setAllData] = useState([]);
  const [seachData, setSeachData] = useState([]);
  const [pprojectData, setPprojectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState(null);
  const [dateRange, setDateRange] = useState([oneYearAgo, today]);
  const RangePicker = DatePicker.RangePicker;
  // const largeScreen = useWindowWide(668);

  const cardTypes = {
    total: 'Total',
    unassigned: type.NOPROJECT,
    nonBillable: type.NONBILLABLE,
    billable: type.BILLABLE
  };

  const defaultCardData = Object.keys(cardTypes).map((key) => ({
    label: cardTypes[key],
    value: 0
  }));

  const [cardData, setCardData] = useState(defaultCardData);
  const [cardLoading, setCardLoading] = useState(false);
  console.log(cardData, 'cardData');
  console.log(cardLoading, 'cardLoading');

  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);
  const select = reportType;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const paginatedData = useMemo(() => {
    const start = (page - 1) * pageSize;
    return allData.slice(start, start + pageSize).map((item, index) => ({
      ...item,
      key: start + index + 1
    }));
  }, [allData, page, pageSize]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const apiMap = {
        [type.BILLABLE]: getBillableFullTimeEmployees,
        [type.NONBILLABLE]: getNonBillableFullTimeEmployees,
        [type.ACTIVE_DAYS]: getEmployeeActiveProjectsByRange,
        [type.BILLING_HOURS]: getEmployeeWiseBillingReportingByRange,
        [type.DEPARTMENTS_BILLING]: getEmployeeDepartmentWiseBiliingByRange,
        [type.ACTIVE_PROJECT_BILLING]: getEmployeeActiveProjectBilling,
        [type.TOTAL_LEAVES_BY_EMPLOYEES]: getTotalLeavesEmployees,
        [type.CLIENT_TOTAL_BILLING]: getTotalClientBilling
      };

      const apiPath = apiMap[select] ?? getNoProjectEmployees;

      const params = new URLSearchParams();
      if (
        [
          type.BILLING_HOURS,
          type.ACTIVE_DAYS,
          type.DEPARTMENTS_BILLING,
          type.TOTAL_LEAVES_BY_EMPLOYEES
        ].includes(select)
      ) {
        params.append('startDate', dateRange?.[0]?.format('YYYY-MM-DD'));
        params.append('endDate', dateRange?.[1]?.format('YYYY-MM-DD'));
      }
      search && params.append('search_key', search);
      const res = await apiPath(params.toString());
      if (res?.statusCode === 200) {
        setAllData(res?.data);
        setSeachData(res?.data);
        page !== 1 && setPage(1);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  // test Comment

  const handleCardData = async () => {
    try {
      setCardLoading(true);
      let res = await getEmployeeProjectBillingCounts();
      if (res?.statusCode === 200) {
        const result = Object.keys(cardTypes).map((key) => ({
          label: cardTypes[key],
          value: res?.data?.[key] || 0
        }));
        setCardData(result);
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setCardLoading(false);
    }
  };
  const HandleOneYearAgo = () => setDateRange([oneYearAgo, today]);

  const handleSearchChange = (value) => {
    if (value !== undefined && value !== null) {
      const searchValue = value.toLowerCase();

      const keyMap = {
        [type.DEPARTMENTS_BILLING]: 'department_name',
        [type.ACTIVE_PROJECT_BILLING]: 'project_name',
        [type.CLIENT_TOTAL_BILLING]: 'name'
      };

      let list;

      if (keyMap[select]) {
        list = seachData?.filter((item) =>
          item?.[keyMap[select]]?.toLowerCase().includes(searchValue)
        );
      } else {
        list = seachData?.filter((item) =>
          `${item?.first_name || ''} ${item?.last_name || ''}`.toLowerCase().includes(searchValue)
        );
      }

      setAllData(list);
    }
  };
  const optimizedFn = useCallback(debounce(handleSearchChange), [search]);

  useEffect(() => {
    if (search !== null) {
      optimizedFn(search);
    } else {
      fetchData();
    }
  }, [select, search, dateRange]);

  useEffect(() => {
    handleCardData();
  }, []);

  const columns = [
    {
      title: 'S.NO',
      dataIndex: 'key',
      key: 'key',
      render: (text) => <span>{text}.</span>
    },
    {
      title: 'Emp Code',
      dataIndex: 'emp_code',
      key: 'emp_code'
    },
    {
      title: 'Name',
      render: (_, data) => {
        const empName = getFullName(data?.first_name, data?.middle_name, data?.last_name);
        const id = data?.id || data?.employee_id;
        const empData = [
          {
            name: empName,
            src: generateEmployeeImgUrl(id),
            id: id,
            completionColor: data?.profile_completion
          }
        ];
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'}>
            <AvatarGroup avatars={empData} />
            <HighlightText
              onClick={() =>
                navigate(`/view-employee`, {
                  state: { name: empName, id: id }
                })
              }>
              {empName}
            </HighlightText>
          </FlexWrapper>
        );
      }
    },
    {
      title: 'Department',
      render: (val) => <span>{val?.department || val?.department_name || 'N/A'}</span>
    },
    ...(select === type.NOPROJECT
      ? [
          {
            title: 'Last Assigned Project',
            dataIndex: 'previous_project',
            key: 'previous_project',
            render: (text) => {
              return <span>{text ? text?.name : 'N/A'}</span>;
            }
          },
          {
            title: 'Idle Since',
            dataIndex: 'lastRemovedAt',
            key: 'lastRemovedAt',
            width: 130,
            render: (text) => <span>{text ? convertToLocalDate(text) : 'N/A'}</span>
          },
          {
            title: 'Idle Days',
            dataIndex: 'lastRemovedAt',
            key: 'lastRemovedAt',
            sorter: (a, b) => {
              if (a.lastRemovedAt === null) return 1;
              if (b.lastRemovedAt === null) return -1;
              return dayjs(a.lastRemovedAt) - dayjs(b.lastRemovedAt);
            },
            render: (_, record) => (
              <span>{record?.lastRemovedAt ? formatDuration(record?.lastRemovedAt) : 'N/A'}</span>
            )
          }
        ]
      : select === type.ACTIVE_DAYS
      ? [
          {
            title: 'Total Work Days',
            dataIndex: 'total_work_days',
            key: 'total_work_days'
          },
          {
            title: 'Total Non Work Days',
            dataIndex: 'total_non_work_days',
            key: 'total_non_work_days'
          },
          {
            title: 'Total Range Days',
            dataIndex: 'total_range_days',
            key: 'total_range_days'
          },
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            className: 'action-column',
            render: (_, data) => {
              return (
                <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'}>
                  <ViewIconBox onClick={() => handleRowClick(data)}>
                    <ViewIconNew />
                  </ViewIconBox>
                </FlexWrapper>
              );
            }
          }
        ]
      : select === type.TOTAL_LEAVES_BY_EMPLOYEES
      ? [
          {
            title: 'Total Leaves',
            dataIndex: 'total_leaves',
            key: 'total_leaves'
          }
        ]
      : select === type.BILLING_HOURS
      ? [
          {
            title: 'Total Billing Hours',
            dataIndex: 'total_mins',
            key: 'total_mins',
            render: (value, record) => {
              return (
                <ProjectBillingTooltip
                  value={value}
                  projectBilling={record?.project_billing}
                  loading={loading}
                />
              );
            }
          }
        ]
      : [
          {
            title: 'Assigned Project',
            render: (_, record) => {
              let val = record?.non_billable_projects || record?.billable_projects;
              return val?.join(', ');
            }
          }
        ])
  ];

  const handleRowClick = (record) => {
    const data = record?.periods;
    if (data.length === 0) {
      toast.info('No project found');
      return;
    }
    setPprojectData(data);
    setIsModalOpen(true);
  };
  const breadcrumbArr = [
    {
      title: <LinkStyled to="/reports">Reports</LinkStyled>
    },
    {
      title: select
    }
  ];
  return (
    <>
      <DetailsDayModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        project={pprojectData}
      />
      <div style={{ background: '#f3f6fc' }}>
        {/* <FlexWrapperCard cols={4}>
          <ReportsCard cardData={cardData} cardLoading={cardLoading} />
        </FlexWrapperCard> */}

        <StickyBox>
          <FlexWrapper justify="space-between" gap="10px">
            <Breadcrumb items={breadcrumbArr} />
            <SearchHeader>
              <SearchField
                placeholder="Search by Employee Name..."
                width={`250px`}
                onChange={(val) => {
                  setSearch(val);
                }}
                value={search}
              />
              {[type.ACTIVE_DAYS, type.BILLING_HOURS, type.TOTAL_LEAVES_BY_EMPLOYEES].includes(
                select
              ) && (
                <DateFlexBox align="center" cursor="default" wrap="nowrap" gap="4px">
                  <LmsIcon />
                  <RangePicker
                    allowClear={false}
                    format={'YYYY-MM-DD'}
                    suffixIcon={null}
                    onChange={(val) => {
                      if (val && val[0] && val[1]) {
                        const [start, end] = val[0].isBefore(val[1])
                          ? [val[0], val[1]]
                          : [val[1], val[0]];
                        setDateRange([start, end]);
                      } else {
                        setDateRange([null, null]);
                      }
                    }}
                    value={[
                      dateRange?.[0]
                        ? dayjs(dateRange?.[0]).isValid()
                          ? dayjs(dateRange?.[0])
                          : null
                        : today, // default start: today
                      dateRange?.[1]
                        ? dayjs(dateRange?.[1]).isValid()
                          ? dayjs(dateRange?.[1])
                          : null
                        : oneYearLater // default end: 1 year later
                    ]}
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                    className="date-range"
                    style={{
                      width: '100%',
                      border: 'none',
                      boxShadow: 'none',
                      outline: 'none',
                      height: '40px',
                      borderRadius: '8px',
                      textAlign: 'center !important'
                    }}
                  />
                  <OneYear onClick={HandleOneYearAgo}>1 Year</OneYear>
                </DateFlexBox>
              )}

              {/* <Select
                suffixIcon={<DropdownIconNew />}
                style={{ width: largeScreen ? '250px' : '100%', height: '40px' }}
                value={select}
                placeholder="Select Range"
                onChange={(val) => setSelect(val)}
                options={selectType}
                disabled={loading}
              /> */}
            </SearchHeader>
          </FlexWrapper>
        </StickyBox>

        {loading || paginatedData.length > 0 ? (
          [type.ACTIVE_PROJECT_BILLING].includes(select) ? (
            loading ? (
              <SkeletonCard />
            ) : (
              <BillingCard data={allData} />
            )
          ) : [type.DEPARTMENTS_BILLING].includes(select) ? (
            loading ? (
              <SkeletonCard />
            ) : (
              <DepartmentCard data={allData} />
            )
          ) : [type.CLIENT_TOTAL_BILLING].includes(select) ? (
            loading ? (
              <SkeletonCardClient />
            ) : (
              <ClientBillingCard data={allData} />
            )
          ) : (
            <Table
              loading={loading}
              prefixCls="antCustomTable"
              columns={columns}
              dataSource={paginatedData}
              pagination={false}
              scroll={{ x: '100%' }}
            />
          )
        ) : (
          <FlexWrapper margin="60px 20px">
            <FlexWrapper direction="column">
              <NoData />
              <Title level={5} style={{ margin: '10px 0 0' }}>
                No Reports
              </Title>
              <DarkText weight="400">Data not found</DarkText>
            </FlexWrapper>
          </FlexWrapper>
        )}

        <PaginationBox>
          <Pagination
            current={page}
            prefixCls="custom-pagination"
            pageSize={pageSize}
            total={allData.length}
            onChange={handlePageChange}
            showSizeChanger={false}
            hideOnSinglePage
          />
        </PaginationBox>
      </div>
    </>
  );
}

export default Reports;

const DateFlexBox = styled.div`
  max-width: 350px;
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '0px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};
  background-color: white;
  padding: 0 0 0 12px;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  @media (max-width: 668px) {
    width: 100%;
    max-width: 100%;
  }
`;
const OneYear = styled.div`
  width: 100px;
  height: 36px;
  background-color: ${({ theme }) => theme.primaryColor};
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SearchHeader = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;
